import { saveDuration } from '@/api/requests/UserRequests'
import { useAuthStore } from '@/stores/login'

const validatePath = () => {
  const token = localStorage.getItem('sandsTalkToken')
  if (token) {
    return true
  }
  return false
}

const setTimer = () => {
  setTimeout(() => {
    if (validatePath()) {
      saveDuration(30)
    }
    setTimer()
  }, 30000)
}

const track = () => {
  setTimer()
}

export default track
